<template>
  <div>
    <topup-radio-button
      id="paymentOptionRadioButton"
      ref="paymentOptionRadioButton"
      :label1="this.$i18n.t('TOPUP.ONCE.ONLINE')"
      :label2="this.$i18n.t('TOPUP.ONCE.VOUCHER')"
      icon1="icon-kreditkarte"
      icon2="icon-ladebon"
    />
    <br>
    <top-up-mpay v-show="this.selectedOneTimeOption === 0"/>
    <top-up-voucher v-show="this.selectedOneTimeOption === 1"/>
  </div>
</template>

<script>
import TopUpMpay from './TopUpMpay.vue';
import TopUpVoucher from './TopUpVoucher.vue';

export default {
  name: "TopUp",
  components: { TopUpVoucher, TopUpMpay },
  data: function() {
    return {
      isMounted: false
    }
  },
  mounted: function() {
    this.isMounted = true;
  },
  computed: {
    selectedOneTimeOption: function() {
      if (this.isMounted && this.$refs.paymentOptionRadioButton) {
        return this.$refs.paymentOptionRadioButton.getValue();
      } else {
        return 0;
      }
    }
  }
}
</script>

<style lang="scss">
.icon-password::before {
    content: url("../../assets/image/icons/Login_Passwort.svg") !important;
  }
  .icon-tan::before {
    content: url("../../assets/image/icons/Login_TAN.svg") !important;
  }
  .icon-kreditkarte::before {
    content: url("../../assets/image/icons/Kreditkarte.svg") !important;
  }
  .icon-ladebon::before {
    content: url("../../assets/image/icons/Ladebon.svg") !important;
  }
</style>
